// libs
import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';
import NFA from 'shared/helpers/analytics/NFAnalytics';
import storage from 'shared/helpers/storage';

// constants
const COUPONS_PAGE_VIEW = 'PDP_COUPON_PAGE_VIEW';

// coupons page view
export const setCouponOfferData = (
  offersCount = 0,
  couponsCount = 0,
  productId: string | number
) => {
  const couponData = {
    pdpCouponsCount: couponsCount,
    pdpOffersCount: offersCount,
    productId,
  };
  storage.setItem(COUPONS_PAGE_VIEW, couponData);
};

// user clicks on details on coupon
export const onPDPCouponViewDetailsClicked = (couponCode: string) => {
  NFA.track({
    event: PDP_EVENTS.COUPON_CLICKED,
    data: {
      couponCode: couponCode,
    },
  });
};

// user clicks on details on offers
export const onPDPOfferViewDetailsClicked = () => {
  NFA.track({
    event: PDP_EVENTS.PDP_OFFER_CLICK,
  });
};
